export default "__VITE_ASSET__bee436bb__"